/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MonitoringControllerDtoWalletListWalletData model module.
 * @module model/MonitoringControllerDtoWalletListWalletData
 * @version 1.0
 */
class MonitoringControllerDtoWalletListWalletData {
    /**
     * Constructs a new <code>MonitoringControllerDtoWalletListWalletData</code>.
     * @alias module:model/MonitoringControllerDtoWalletListWalletData
     */
    constructor() { 
        
        MonitoringControllerDtoWalletListWalletData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MonitoringControllerDtoWalletListWalletData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoWalletListWalletData} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoWalletListWalletData} The populated <code>MonitoringControllerDtoWalletListWalletData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoWalletListWalletData();

            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('balancePer')) {
                obj['balancePer'] = ApiClient.convertToType(data['balancePer'], 'Number');
            }
            if (data.hasOwnProperty('balanceXper')) {
                obj['balanceXper'] = ApiClient.convertToType(data['balanceXper'], 'Number');
            }
            if (data.hasOwnProperty('balanceHvh')) {
                obj['balanceHvh'] = ApiClient.convertToType(data['balanceHvh'], 'Number');
            }
            if (data.hasOwnProperty('balanceUsdt')) {
                obj['balanceUsdt'] = ApiClient.convertToType(data['balanceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('balanceArb')) {
                obj['balanceArb'] = ApiClient.convertToType(data['balanceArb'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
            if (data.hasOwnProperty('walletDesc')) {
                obj['walletDesc'] = ApiClient.convertToType(data['walletDesc'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoWalletListWalletData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoWalletListWalletData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['walletDesc'] && !(typeof data['walletDesc'] === 'string' || data['walletDesc'] instanceof String)) {
            throw new Error("Expected the field `walletDesc` to be a primitive type in the JSON string but got " + data['walletDesc']);
        }

        return true;
    }


}



/**
 * @member {Number} walletNo
 */
MonitoringControllerDtoWalletListWalletData.prototype['walletNo'] = undefined;

/**
 * @member {Number} accountNo
 */
MonitoringControllerDtoWalletListWalletData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
MonitoringControllerDtoWalletListWalletData.prototype['email'] = undefined;

/**
 * @member {Number} balancePer
 */
MonitoringControllerDtoWalletListWalletData.prototype['balancePer'] = undefined;

/**
 * @member {Number} balanceXper
 */
MonitoringControllerDtoWalletListWalletData.prototype['balanceXper'] = undefined;

/**
 * @member {Number} balanceHvh
 */
MonitoringControllerDtoWalletListWalletData.prototype['balanceHvh'] = undefined;

/**
 * @member {Number} balanceUsdt
 */
MonitoringControllerDtoWalletListWalletData.prototype['balanceUsdt'] = undefined;

/**
 * @member {Number} balanceArb
 */
MonitoringControllerDtoWalletListWalletData.prototype['balanceArb'] = undefined;

/**
 * @member {Date} createdAt
 */
MonitoringControllerDtoWalletListWalletData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
MonitoringControllerDtoWalletListWalletData.prototype['updatedAt'] = undefined;

/**
 * @member {String} walletDesc
 */
MonitoringControllerDtoWalletListWalletData.prototype['walletDesc'] = undefined;






export default MonitoringControllerDtoWalletListWalletData;

